import config from "config";
import { createZoovuAdapter } from "./adapters/zoovu";
import { createClientAdapter } from "./adapters/client";

const ADAPTER_TYPES = {
  zoovu: createZoovuAdapter,
  client: createClientAdapter,
};

function createAdapter(backendConfig) {
  const type = backendConfig.type || "zoovu";
  const factory = ADAPTER_TYPES[type];

  if (!factory) {
    console.error(
      `Unknown search adapter type: "${type}". Available types: ${Object.keys(ADAPTER_TYPES).join(", ")}`,
    );
    return null;
  }

  return factory(backendConfig);
}

const adapter = createAdapter(config.backend);

export const fetchResult = (searchOptions) => {
  return adapter.fetchResult(searchOptions);
};

/**
 * @param {String} query
 * @param {number} limit
 * @return {Promise}
 */
export const fetchSuggestions = (query, limit) => {
  return adapter.fetchSuggestions(query, limit);
};

export default fetchResult;
